import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import {
  AgrLogoWideModule,
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrPrintPageModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { AgrTableModule } from '@next/core-lib/table';
import { LetDirective, PushPipe } from '@ngrx/component';

import { GeneralInfoComponent } from './components/general-info/general-info.component';
import { EnvironmentalImpactReportComponent } from './environmental-impact-report/environmental-impact-report';
import { FertilizationLegalStandardsComponent } from './fertilization-legal-standards/fertilization-legal-standards.component';
import { FertilizationTableReportComponent } from './fertilization-table-report/fertilization-table-report.component';
import { NutrientBalanceReportComponent } from './nutrient-balance-report/nutrient-balance-report.component';
import { OrganicMatterReportComponent } from './organic-matter-report/organic-matter-report.component';
import { PlanetProofReportComponent } from './planet-proof-report/planet-proof-report.component';
import { ReportComponent } from './report/report.component';
import { SkalReportComponent } from './skal-report/skal-report.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    GeneralInfoComponent,
    FertilizationLegalStandardsComponent,
    ReportComponent,
    SkalReportComponent,
    FertilizationTableReportComponent,
    OrganicMatterReportComponent,
    NutrientBalanceReportComponent,
    EnvironmentalImpactReportComponent,
    PlanetProofReportComponent,
  ],
  imports: [
    SharedModule,
    LetDirective,
    PushPipe,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatTableModule,
    AgrPageToolbarModule,
    AgrValueRowModule,
    AgrLogoWideModule,
    AgrPrintPageModule,
    AgrPageDetailModule,
    AgrTableModule,
    CommonModule,
    AgrI18nSharedModule,
  ],
})
export class ReportsModule {}
